import React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { AffiliateModel } from '@mm/state/model/AffiliateModel';

type Props = {
  affiliate?: AffiliateModel;
};

export default ({ affiliate }: Props) => {
  const refLink = `https://mobilemonkey.postaffiliatepro.com/`;
  const statusClass =
    affiliate && affiliate.approved
      ? 'affiliate-panel__active-state'
      : 'affiliate-panel__inactive-state';

  return (
    <div className="affiliate-panel__info">
      <p className="affiliate-panel__info-welcome">
        Customers.ai has partnered with PostAffiliatePro to bring you the best
        affiliate experience possible! Check out the link below for more
        details.
      </p>
      {affiliate && (
        <p>
          Your affiliate account is &nbsp;
          <span className={statusClass}>
            {affiliate.approved ? 'Active ' : 'Deactivated '}
          </span>
          however we are sunsetting this program. Please use the link below to
          register with PostAffiliatePro to continue earning affiliate
          commissions. Contact{' '}
          <a href="mailto: affiliate@customers.ai">affiliate@customers.ai</a>{' '}
          with any questions!.
        </p>
      )}
      {!affiliate && (
        <>
          <p className="affiliate-panel__signup-heading">
            Sign Up below to activate your link!
          </p>
        </>
      )}
      <CopyToClipboard text={refLink}>
        <span className="affiliate-panel__copy-link">
          {refLink}&nbsp;
          <i className="fa fa-copy" />
        </span>
      </CopyToClipboard>
    </div>
  );
};
